









import JourneyParameters from '@/models/interfaces/JourneyParameters';
import SurveyAnswer from '@/models/SurveyAnswer';
import { Rating } from '@solucx/indicators';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class AcceptanceContactIfNeutral extends Vue {
  @Prop() public readonly value!: boolean;
  @Prop() public readonly rating!: SurveyAnswer;
  @Prop({ required: true }) public readonly parameters!: JourneyParameters;

  public get acceptanceContactIfNeutral(): boolean {
    return this.value;
  }

  public set acceptanceContactIfNeutral(value: boolean) {
    this.$emit('input', value);
  }

  public get shouldContactIfNeutral(): boolean {
    return this.isNeutral && this.parameters.showAcceptanceContactIfNeutral === true;
  }

  public get isNeutral(): boolean {
    return this.rating.getRating() === Rating.NEUTRAL;
  }

  public get customAcceptanceContactText(): string {
    const { customAcceptanceContactText } = this.parameters;
    return customAcceptanceContactText ? customAcceptanceContactText : this.$tc('generic.acceptanceContact');
  }

  @Watch('shouldContactIfNeutral')
  public onChangedActiveContactIfNeutral(): void {
    this.$emit('shouldContactIfNeutralChanged');
  }
}
